module.exports = __webpack_public_path__ + "img/photo-02.8e5779b1.png";